import { ChatbotUIAction } from '@wix/ambassador-funnel-chatbot-v1-session/types';
import { useSelector } from 'react-redux';
import { Store } from 'redux';

import { useHttpClient } from '../providers/httpClient';
import { TRootState } from '../reducers';
import { selectLoadPageUrl } from '../selectors/meta';
import { sendUserAction } from './sendUserAction';

export const sendNavigatedAction =
  (store: Store<TRootState>) => (navigated: { url?: string; navigationFailed?: boolean }) => {
    const httpClient = useHttpClient();
    const loadPageUrl = useSelector(selectLoadPageUrl);
    if (!navigated?.url) {
      return;
    }
    const {
      chat: { conversationId },
    } = store.getState();
    return sendUserAction(
      {
        type: ChatbotUIAction.NAVIGATED,
        navigated,
      },
      conversationId,
      undefined,
      httpClient,
      loadPageUrl,
    );
  };
